import React from 'react'
import Header from '../components/header';
import OurCeo from '../components/ourceo'
import Footer from '../components/footer';

const OurCeoPage = () => {
  return (
    <>
      {<Header/>}
      {<OurCeo/>}
      {<Footer/>}
    </>
  )
}

export default OurCeoPage
